import { render, staticRenderFns } from "./UploadModal.vue?vue&type=template&id=37a6b39c"
import script from "./UploadModal.vue?vue&type=script&lang=js"
export * from "./UploadModal.vue?vue&type=script&lang=js"
import style0 from "./UploadModal.vue?vue&type=style&index=0&id=37a6b39c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports